function CopyIcon({ color, opacity = 0.2 }) {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.15321 8.15242H10.962V0.662354H3.47192V3.47113M0.663086 3.4712H8.15315V10.9613H0.663086V3.4712Z"
                stroke="white"
                strokeWidth="1.24834"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default CopyIcon;
